import React, { useCallback, useEffect, useState } from 'react';
import { Content, PageHeader, Spinner, AlertBar, Tabs, Tab, TabList, TabContent } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';
import { PageHeaderContainer, DeviceNameLabel, SpinnerDesign, Divider, NoteLabel, CenterAlignedContainer } from '../Style';
import { getCameraList } from '../apis';
import CameraSttings from './CameraSettings';
import { useDevice } from '../hooks/useDevice';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const RowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const CameraRowOne = styled.div`
  display: flex;
`;
const CameraRowTwo = styled.div`
  display: flex;
  margin-top: 14px;
`;

function DetectionSettings() {
  const [cameras, setCameras] = useState<string[]>([]);
  const { state: { device, status_code, deviceLoading }, actions: { fetchDevice } } = useDevice();
  const [loading, setLoading] = useState<boolean>(true);
  const [alert, setAlert] = useState<{ key: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });
  const { t } = useTranslation(['DetectionSettings', 'Common']);
  const location = useLocation();

  const getCameras = useCallback(() => {
    getCameraList()
      .then((res) => {
        if (res.data.status_code === '0') {
          setCameras(res.data.data);
          if (res.data.data.length <= 0) {
            setAlert({ key: new Date(), message: t('Common:noCamerasFound'), type: 'info' });
          }
        } else {
          setAlert({ key: new Date(), message: res.data.message, type: 'info' });
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.data.message) {
          setAlert({ key: new Date(), message: err.response.data.message, type: 'error' });
          setLoading(false);
        }
        console.error(err);
      });
  }, [t]);

  useEffect(() => {
    if(status_code === '0'){
      getCameras();
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getCameras, status_code]);

  useEffect(() => {
    if (!deviceLoading) {
      if (status_code === '2') {
        setAlert({ key: new Date(), message: t('Common:deviceNotFound'), type: 'info' });
      }
    }
  }, [device, status_code, deviceLoading, t]);

  useEffect(() => {
    fetchDevice();
  }, [fetchDevice]);

  useEffect(() => {
    sessionStorage.removeItem('notificatioinTab');
    sessionStorage.removeItem('auditLogTab');
  }, [location]);

  return (
    <Content>
      <PageHeaderContainer>
        <PageHeader title={t('detectionAnalysis')} icon='Analyse' areaTitle={t('Common:home')} areaHref='/' />
        <DeviceNameLabel htmlFor='' labelText={device.name} />
        <NoteLabel htmlFor='' labelText={device.detail} />
      </PageHeaderContainer>
      {
        (deviceLoading || loading) ?
          <CenterAlignedContainer>
           <Spinner size='large' styling={SpinnerDesign} /> 
          </CenterAlignedContainer> :
          (alert.message !== '' ? <AlertBar key={alert.key} type={alert.type} message={alert.message} /> : null)
      }
      {
        !loading && cameras &&
          <Tabs>
            <TabList defaultTabId={ sessionStorage.getItem('cameraTab') || cameras[0]}>
              <RowContainer>
                <div>
                  <CameraRowOne>
                    {
                      cameras.slice(0,5).map((camera) => (
                        <Tab tabFor={camera} key={camera} onClick={()=>sessionStorage.setItem('cameraTab',camera)}>
                          {camera}
                        </Tab>
                      ))
                    }
                  </CameraRowOne>
                  <Divider />                
                </div>
                <div>
                  <CameraRowTwo>
                    {
                      cameras.slice(5,10).map((camera) => (
                        <Tab tabFor={camera} key={camera} onClick={()=>sessionStorage.setItem('cameraTab',camera)}>
                          {camera}
                        </Tab>
                      ))
                    }
                  </CameraRowTwo>
                  <Divider />
                </div>
              </RowContainer>
            </TabList>
            {
              cameras.map((camera) => <TabContent key={camera} tabId={camera}><CameraSttings cameraName={camera} device={device} /> </TabContent>
              )
            }
          </Tabs>
      }

    </Content>
  );
}
export default DetectionSettings;
